import { useTranslation } from 'react-i18next';

import UniversalButton from "components/uiComponents/UniversalButton";
import "./ConfirmActionModal.scss";

const ConfirmActionModal = (props) => {
  const { title, onClose, confirmCallback, description, confirmButtonText } = props;
  const { t } = useTranslation();

  return (
    <div className="confirm-action-modal">
      <div className="confirm-action-modal__container">
        <p className="confirm-action-modal__title">{title}</p>

        <p 
          className="confirm-action-modal__text"
        >
          {description}
        </p>
      </div>
      <div className="modal_btns">
        <UniversalButton
          type="button"
          label={t('go_back')}
          size="lg"
          labelColor="blue"
          labelHoverColor="blue"
          backgroundColor="white"
          backgroundHoverColor="blue-light"
          onClick={onClose}
        />

        <UniversalButton
          type="button"
          label={confirmButtonText}
          size="lg"
          onClick={confirmCallback}
          labelColor="white"
          labelHoverColor="white"
          backgroundColor="orange"
          backgroundHoverColor="orange-light"
        />
      </div>
    </div>
  );
};

export default ConfirmActionModal;
